import {
  Toolbar
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DialogHeader = (props) => {
  return (
    <div className="dialog-header">
      <Toolbar className="flex w-full justify-between p-6">
        <div>
          {props.title}
        </div>

        <div className='cursor-pointer' onClick={props.onClose}>
          <CloseIcon style={{ fontSize: 34, backgroundColor: "#F2F4F7" }} />
        </div>
      </Toolbar>
    </div>
  )
}

export default DialogHeader;
